import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Box,
  Typography,
} from '@mui/material';
import { formatCurrency } from 'components/shared';

const OrderItems = ({ order }) => {
  const items = order?.items || [];

  return (
    <Paper sx={{ width: '100%', overflow: 'hidden', mt: 2 }}>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>SL</TableCell>
              <TableCell>Item Details</TableCell>
              <TableCell>Item Price</TableCell>
              <TableCell>Tax</TableCell>
              <TableCell>Quantity</TableCell>
              <TableCell>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, index) => {
              const product = item.product || {};
              return (
                <TableRow key={product._id || index}>
                  <TableCell>{index + 1}</TableCell>
                  <TableCell>
                    <Box>
                      <Typography variant="body2">{product.name || 'Unknown product'}</Typography>
                      <Typography variant="caption">Code: {product.productCode || '—'}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>{formatCurrency(item.price)}</TableCell>
                  <TableCell>{formatCurrency(item.tax)}</TableCell>
                  <TableCell>{item.quantity || 0}</TableCell>
                  <TableCell>{formatCurrency(item.total)}</TableCell>
                </TableRow>
              );
            })}
            {items.length === 0 && (
              <TableRow>
                <TableCell colSpan={6} align="center">No items</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default OrderItems;
